import { render, staticRenderFns } from "./Dialog_ChangeCourse.vue?vue&type=template&id=0b296d61&"
import script from "./Dialog_ChangeCourse.vue?vue&type=script&lang=js&"
export * from "./Dialog_ChangeCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports